module.exports = __webpack_public_path__ + "static/media/changjiang.11779776.png";